import { Injectable } from '@angular/core'
import { Effect, Actions, ofType } from '@ngrx/effects'
import { of } from 'rxjs/observable/of'
import { map, switchMap } from 'rxjs/operators'

import * as Menu from '../actions/menu.actions'
import * as App from '../../../../../store/actions/app.actions'

@Injectable()
export class MenuEffects {

  constructor(private actions$: Actions) {
  }

  @Effect()
  selectMenuItem$ = this.actions$.pipe(
    ofType(Menu.SELECT_MENU_ITEM),
    map((action: Menu.SelectMenuItem) => action.payload),
    switchMap(route => of(new App.Go({path: [route]}))))
}



// WEBPACK FOOTER //
// ./src/app/shared/navbar/menu/store/effects/menu.effects.ts